import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import * as XLSX from "xlsx";
import moment from "moment";

const DemoFertilizerTrialReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  
 const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };

  const [loading, setLoading] = useState(false);

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getCropCutData } = useHttp();

  const fillCropCutData = async (
    employeeId,
    regionId,
    farmerNo,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/fertilizerTrialReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getCropCutData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        if (getType == "Excel") {
          console.log("reportdata", data);
          // const handleDownload = async () => {
          //   const blob = await data.blob();
          //   const url = window.URL.createObjectURL(blob);
          //   const link = document.createElement('a');
          //   link.href = url;
          //   link.download = 'downloaded-file.csv'; // Set the file name here
          //   link.click();
          // }
        } else {
          console.log("reportdata", data);
          setData(data);
        }
      }
    );
  };

  const excelDownload = async (
    employeeId,
    regionId,
    farmerNo,
    getType = "Excel"
  ) => {
    setLoading(true);
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `${
      process.env.REACT_APP_BASE_URL
    }/api/fertilizerTrialReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        authorization: `Bearear ${localStorage.getItem("token")}`,
      });

      if (!response.ok) {
        console.error(`Error ${response.status}: ${response.statusText}`);
        setLoading(false);
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);

      console.log(downloadUrl);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "FertiliserTrial(B).xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  useEffect(() => {
    fillCropCutData(0, 0, "");
  }, [getCropCutData]);

  const customHeaders = [
    "Executive Name",
    "Farmer's Name",
    "Season Name",
    "LGA",
    "Community",
    "State",
    "Lat",
    "Long",
    "Crop Name",
    "Variety of Seed Sown",
    "Date of Planting",
    "Plot size (m2)",
    "Plot size (Ha)",
    "NPK Fertiliser Type",
    "Date of 1st Fertiliser doze (NPK)",
    "Date of 2nd Fertiliser doze (NPK)",
    "NPK Application Rate (Bags)",
    "NPK Unit Name",
    "Urea Fertiliser Type",
    "Urea Application Date",
    "Urea Application Rate (Bags)",
    "Urea Unit Name",
    "Date of Weed Control 1",
    "Weed control method 1",
    "Date of Weed Control 2",
    "Weed control method 2",
    "Date of Weed Control 3",
    "Weed control method 3",
    "No of Days to tasseling",
    "Plant height (cm) @ 10 WAP",
    "Stem Girth (mm) @ 10 WAP",
    "Leaf Area (cm) @ 10 WAP",
    "Harvest date",
    "Crop cut weight A (kg)",
    "Crop cut weight B (kg)",
    "Crop cut weight C (kg)",
    "Average Crop Cut Weight (A,B,C)",
    "Yield (0.05 hectare) (TON)",
    "Yield(MT/HA)",
    "Farmers' previous Yield/Ha(T0N)",
    "Grain Moisture @ threshing",
    "Crop Cut Dates",
    "Harvest Dates",
  ];

  const fieldsToExport = [
    "executiveName",
    "farmerName",
    "seasonName",
    "lga",
    "communityName",
    "state",
    "entryLatLong.latitude",
    "entryLatLong.longitude",
    "cropName",
    "varietyOfSeedSownName",
    "dateOfPlanting",
    "plotSizeM2",
    "plotSizeHa",
    "npkProductName",
    "dateof1stfertilzierdose",
    "dateof2stfertilzierdose",
    "npkApplicationRateBags",
    "npkUnitName",
    "ureaProductName",
    "ureaApplicationDate",
    "ureaApplicationRateBags",
    "ureaUnitName",
    "dateOfWeedControl1",
    "WeedControlMethod1",
    "dateOfWeedControl2",
    "WeedControlMethod2",
    "dateOfWeedControl3",
    "WeedControlMethod3",
    "noOfDaysTasseling",
    "plantHeightcm10wap",
    "stemGirthmm10wap",
    "leafAreacm10wap",
    "harvestDate",
    "cropCutWeightAKg",
    "cropCutWeightBKg",
    "cropCutWeightCKg",
    "averageCropCutWeightABCKg",
    "yieldPoint05HectareTon",
    "yieldMtPerTon",
    "previousYieldperHaTon",
    "grainMoistureAtThreshing",
    "cropCutDate",
    "harvestDate",
  ];

  const handleExportExcel = () => {
    const filename = "Fertiliser Trial(B).xlsx";

    const processedData = data.map((item) => {
      let latitude = "";
      let longitude = "";

      if (item.entryLatLong) {
        let coordinates = item.entryLatLong;

        if (typeof coordinates === "string") {
          try {
            coordinates = JSON.parse(coordinates);
          } catch (e) {
            console.error("Invalid coordinates string", e);
            coordinates = null;
          }
        }

        if (Array.isArray(coordinates)) {
          latitude = coordinates.map((c) => c.latitude ?? "").join(", ");
          longitude = coordinates.map((c) => c.longitude ?? "").join(", ");
        } else if (coordinates && typeof coordinates === "object") {
          latitude = coordinates.latitude ?? "";
          longitude = coordinates.longitude ?? "";
        }
      }
      return {
        ...item,
        latitude,
        longitude,
      };
    });

    convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        // console.log("farmerNumberList", data);

        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title">Fertiliser Trial (B)</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setData([]);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillCropCutData(employeeId, regionId, farmerNumber);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>

              {/* <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={(e) => {
                  excelDownload(employeeId, regionId, farmerNumber, "Excel");
                }}
                disabled={loading}
              > */}
              {/* {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>
                    <i className="fas fa-file-image"></i>
                  </>
                )} */}
              {/* </button> */}
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>S/N</th>
                          <th>Executive Name</th>
                          <th>Farmer's Name</th>
                          <th>Season Name</th>
                          <th>LGA</th>
                          <th>Community</th>
                          <th>State</th>
                          <th>Lat</th>
                          <th>Long</th>
                          <th>Crop Name</th>
                          <th>Variety of Seed Sown</th>
                          <th>Date of Planting</th>
                          <th>Plot size (m2)</th>
                          <th>Plot size (Ha)</th>
                          <th>NPK Fertiliser Type</th>
                          <th>Date of 1st Fertiliser doze (NPK)</th>
                          <th>Date of 2nd Fertiliser doze (NPK)</th>
                          <th>NPK Application Rate (Bags)</th>
                          <th>NPK Unit Name</th>
                          <th>Urea Fertiliser Type</th>
                          <th>Urea Application Date</th>
                          <th>Urea Application Rate (Bags)</th>
                           <th>Urea Unit Name</th>
                          <th>Date of Weed Control 1</th>
                          <th>Weed control method 1</th>
                          <th>Date of Weed Control 2</th>
                          <th>Weed control method 2</th>
                          <th>Date of Weed Control 3</th>
                          <th>Weed control method 3</th>
                          <th>No of Days to Tasseling</th>
                          <th>Plant height (cm) @ 10 WAP</th>
                          <th>Stem Girth (mm) @ 10 WAP</th>
                          <th>Leaf Area (cm) @ 10 WAP</th>
                          <th>Harvest date</th>
                          <th>Crop cut weight A (kg)</th>
                          <th>Crop cut weight B (kg)</th>
                          <th>Crop cut weight C (kg)</th>
                          <th>Average Crop Cut Weight (A,B,C)</th>
                          <th>Yield (0.05 hectare) (TON)</th>
                          <th>Yield (MT/HA)</th>
                          <th>Farmers' previous Yield/Ha (TON)</th>
                          <th>Grain Moisture @ threshing</th>
                          <th>Crop Cut Dates</th>
                          <th>Harvest Dates</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => (
                            <tr key={i} className="tablerowview">
                              <td>{i + 1}</td>
                              <td>{itm.executiveName}</td>
                              <td>{itm.farmerName}</td>
                              <td>{itm.seasonName}</td>
                              <td>{itm.lga}</td>
                              <td>{itm.communityName}</td>
                              <td>{itm.state}</td>
                              <td>
                                {itm.plotCoordinates &&
                                typeof itm.plotCoordinates === "string" &&
                                itm.plotCoordinates.trim().startsWith("[") ? (
                                  JSON.parse(itm.plotCoordinates).map(
                                    (coord, index) => (
                                      <div key={index}>
                                        {coord.latitude || ""}
                                      </div>
                                    )
                                  )
                                ) : (
                                  <div></div>
                                )}
                              </td>
                              <td>
                                {itm.plotCoordinates &&
                                typeof itm.plotCoordinates === "string" &&
                                itm.plotCoordinates.trim().startsWith("[") ? (
                                  JSON.parse(itm.plotCoordinates).map(
                                    (coord, index) => (
                                      <div key={index}>
                                        {coord.longitude || ""}
                                      </div>
                                    )
                                  )
                                ) : (
                                  <div></div>
                                )}
                              </td>

                              {/* <td>
                                {itm.plotCoordinates &&
                                  JSON.parse(itm.plotCoordinates).map(
                                    (coord, index) => (
                                      <div key={index}>{coord.longitude}</div>
                                    )
                                  )}
                              </td> */}
                              <td>{itm.cropName}</td>
                              <td>{itm.varietyOfSeedSownName}</td>
                              <td>{itm.dateOfPlanting}</td>
                              <td>{itm.plotSizeM2}</td>
                              <td>{itm.plotSizeHa}</td>
                              <td>{itm.npkProductName}</td>
                              <td>{itm.dateof1stfertilzierdose}</td>
                              <td>{itm.dateof2stfertilzierdose}</td>
                              <td>{itm.npkApplicationRateBags}</td>
                              <td>{itm.npkUnitName}</td>
                              <td>{itm.ureaProductName}</td>
                              <td>{itm.ureaApplicationDate}</td>
                              <td>{itm.ureaApplicationRateBags}</td>
                              <td>{itm.ureaUnitName}</td>
                              <td>{itm.dateOfWeedControl1}</td>
                              <td>{itm.WeedControlMethod1}</td>
                              <td>{itm.dateOfWeedControl2}</td>
                              <td>{itm.WeedControlMethod2}</td>
                              <td>{itm.dateOfWeedControl3}</td>
                              <td>{itm.WeedControlMethod3}</td>
                              <td>{itm.noOfDaysTasseling}</td>
                              <td>{itm.plantHeightcm10wap}</td>
                              <td>{itm.stemGirthmm10wap}</td>
                              <td>{itm.leafAreacm10wap}</td>
                              <td>{itm.harvestDate}</td>
                              <td>{itm.cropCutWeightAKg}</td>
                              <td>{itm.cropCutWeightBKg}</td>
                              <td>{itm.cropCutWeightCKg}</td>
                              <td>{itm.averageCropCutWeightABCKg}</td>
                              <td>{itm.yieldPoint05HectareTon}</td>
                              <td>{itm.yieldMtPerTon}</td>
                              <td>{itm.previousYieldperHaTon}</td>
                              <td>{itm.grainMoistureAtThreshing}</td>
                              <td>{itm.cropCutDate}</td>
                              <td>{itm.harvestDate}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DemoFertilizerTrialReport;
